var Path = require("../Path");

var polyHelper = require("../helper/poly");

/**
 * @module zrender/graphic/shape/Polyline
 */
var _default = Path.extend({
  type: 'polyline',
  shape: {
    points: null,
    smooth: false,
    smoothConstraint: null
  },
  style: {
    stroke: '#000',
    fill: null
  },
  buildPath: function (ctx, shape) {
    polyHelper.buildPath(ctx, shape, false);
  }
});

module.exports = _default;


//////////////////
// WEBPACK FOOTER
// ./~/_zrender@3.7.4@zrender/lib/graphic/shape/Polyline.js
// module id = 1313
// module chunks = 0